var _g, _g2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4516_13124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_4516_13124)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_4516_13124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13086 11.7218C10.6961 9.63485 12.783 5.46094 21.6513 5.46094C29.094 5.46094 33.7331 5.46094 39.3276 5.46094C44.9222 5.46094 49.4091 8.41746 50.9743 11.7218",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 28L29 31L34 26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38C35.523 38 40 33.523 40 28C40 22.477 35.523 18 30 18C24.477 18 20 22.477 20 28C20 29.821 20.487 31.53 21.338 33L20.5 37.5L25 36.662C26.5195 37.5411 28.2445 38.0027 30 38V38Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4516_13124",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4516_13124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4516_13124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4516_13124",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4516_13124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4516_13124",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173913,
    stopColor: "#09A5F5",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6775F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewUs);
export default __webpack_public_path__ + "static/media/review_us.48ff3977b534202df0915bbe0f67ada7.svg";
export { ForwardRef as ReactComponent };